<template>
    <div>
        <v-alert v-if="formattedErrors.length > 0"
                 v-for="(error, index) in formattedErrors"
                 :key="`error${index}`"
                 type="error">
            {{ error }}
        </v-alert>
    </div>
</template>
<script>
    export default {
        name: 'error-list',
        props: {
            errors: {
                required: true,
                type: Object,
            },
        },
        computed: {
            formattedErrors() {
                const formattedErrors = [];
                Object.values(this.errors).forEach(e => formattedErrors.push(...e));
                return formattedErrors;
            },
        },
    }
</script>
